import {
  Dialog,
  DialogActions,
  DialogContent,
  useMediaQuery,
  useTheme,
  Button,
  TextField,
  Box,
  Typography,
  InputAdornment,
  Fade,
  IconButton,
  makeStyles,
  Grow,
  Slide,
  Zoom,
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import bonusProductAPI from '../../middleware/bonusProductAPI';
import { alertError } from '../../Util/Util';
import Swal from 'sweetalert2';
import { trim } from 'lodash';
import SendRoundedIcon from '@material-ui/icons/SendRounded';
import ConfirmationNumberRoundedIcon from '@material-ui/icons/ConfirmationNumberRounded';
import PersonOutlineRoundedIcon from '@material-ui/icons/PersonOutlineRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    backdropFilter: 'blur(8px)',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
  dialogPaper: {
    borderRadius: 24,
    overflow: 'hidden',
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    maxWidth: 480,
    [theme.breakpoints.down('sm')]: {
      margin: 16,
      width: 'calc(100% - 32px)',
    },
  },
  header: {
    padding: theme.spacing(4, 4, 3, 4),
    background:
      'linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(168, 85, 247, 0.1) 100%)',
    position: 'relative',
    borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
  },
  iconWrapper: {
    width: 64,
    height: 64,
    margin: '0 auto 16px',
    borderRadius: '20px',
    background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 10px 30px -5px rgba(99, 102, 241, 0.4)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background:
        'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)',
      animation: '$shimmer 3s infinite',
    },
  },
  '@keyframes shimmer': {
    '0%': {
      left: '-100%',
    },
    '100%': {
      left: '100%',
    },
  },
  iconSvg: {
    fontSize: 36,
    color: '#fff',
  },
  closeButton: {
    position: 'absolute',
    right: 16,
    top: 16,
    width: 36,
    height: 36,
    background: 'rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.1)',
      transform: 'rotate(90deg)',
    },
  },
  content: {
    padding: theme.spacing(3, 4, 2, 4),
    background: 'transparent',
  },
  formGroup: {
    marginBottom: theme.spacing(3),
    position: 'relative',
  },
  label: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: '#1f2937',
    marginBottom: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  inputField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      background: '#fff',
      border: '2px solid #e5e7eb',
      transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
      '& fieldset': {
        border: 'none',
      },
      '&:hover': {
        border: '2px solid #c7d2fe',
        transform: 'translateY(-1px)',
        boxShadow: '0 4px 12px rgba(99, 102, 241, 0.1)',
      },
      '&.Mui-focused': {
        border: '2px solid #6366f1',
        boxShadow: '0 0 0 3px rgba(99, 102, 241, 0.1)',
        transform: 'translateY(-1px)',
      },
      '&.Mui-error': {
        border: '2px solid #ef4444',
        '&.Mui-focused': {
          boxShadow: '0 0 0 3px rgba(239, 68, 68, 0.1)',
        },
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 16px',
      fontSize: '0.938rem',
    },
  },
  infoCard: {
    padding: 16,
    borderRadius: 12,
    background:
      'linear-gradient(135deg, rgba(99, 102, 241, 0.05) 0%, rgba(168, 85, 247, 0.05) 100%)',
    border: '1px solid rgba(99, 102, 241, 0.2)',
    marginTop: 16,
    display: 'flex',
    gap: 12,
    alignItems: 'start',
  },
  validationMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: '0.813rem',
    marginTop: 6,
    fontWeight: 500,
    animation: '$slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  '@keyframes slideIn': {
    from: {
      opacity: 0,
      transform: 'translateY(-4px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  errorMessage: {
    color: '#ef4444',
  },
  successMessage: {
    color: '#10b981',
  },
  actions: {
    padding: theme.spacing(2, 4, 4, 4),
    gap: 12,
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  button: {
    borderRadius: 12,
    padding: '12px 24px',
    fontSize: '0.938rem',
    fontWeight: 600,
    textTransform: 'none',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    flex: 1,
    '&:active': {
      transform: 'scale(0.98)',
    },
  },
  cancelButton: {
    border: '2px solid #e5e7eb',
    color: '#6b7280',
    background: '#fff',
    '&:hover': {
      background: '#f9fafb',
      border: '2px solid #d1d5db',
      transform: 'translateY(-1px)',
    },
  },
  sendButton: {
    background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
    color: '#fff',
    border: 'none',
    boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #4f46e5 0%, #9333ea 100%)',
      boxShadow: '0 8px 24px rgba(99, 102, 241, 0.4)',
      transform: 'translateY(-2px)',
    },
    '&.Mui-disabled': {
      background: '#e5e7eb',
      color: '#9ca3af',
      boxShadow: 'none',
    },
  },
  loadingDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: '#fff',
    display: 'inline-block',
    margin: '0 2px',
    animation: '$bounce 1.4s infinite ease-in-out both',
    '&:nth-child(1)': {
      animationDelay: '-0.32s',
    },
    '&:nth-child(2)': {
      animationDelay: '-0.16s',
    },
  },
  '@keyframes bounce': {
    '0%, 80%, 100%': {
      transform: 'scale(0)',
    },
    '40%': {
      transform: 'scale(1)',
    },
  },
}));

const BonusProductPRVoucherModal = (props) => {
  const { close, isOpen, bonusProductId } = props;
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    userId: '',
    quantity: 1,
  });
  const [validation, setValidation] = useState({
    userId: { isValid: false, message: '' },
    quantity: { isValid: true, message: '' },
  });
  const [touched, setTouched] = useState({
    userId: false,
    quantity: false,
  });

  // 即時驗證
  useEffect(() => {
    validateUserId(formData.userId);
  }, [formData.userId]);

  useEffect(() => {
    validateQuantity(formData.quantity);
  }, [formData.quantity]);

  const validateUserId = (value) => {
    if (trim(value) === '') {
      setValidation((prev) => ({
        ...prev,
        userId: { isValid: false, message: '請輸入用戶 ID' },
      }));
    } else if (!/^\d+$/.test(value)) {
      setValidation((prev) => ({
        ...prev,
        userId: { isValid: false, message: '用戶 ID 必須為純數字' },
      }));
    } else {
      setValidation((prev) => ({
        ...prev,
        userId: { isValid: true, message: '用戶 ID 格式正確' },
      }));
    }
  };

  const validateQuantity = (value) => {
    const num = parseInt(value, 10);
    if (isNaN(num) || num < 1) {
      setValidation((prev) => ({
        ...prev,
        quantity: { isValid: false, message: '數量必須大於 0' },
      }));
    } else if (num > 10000) {
      setValidation((prev) => ({
        ...prev,
        quantity: { isValid: false, message: '單次發送不可超過 10000 張' },
      }));
    } else {
      setValidation((prev) => ({
        ...prev,
        quantity: { isValid: true, message: `將發送 ${num} 張優惠券` },
      }));
    }
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick' && !isLoading) {
      close();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setTouched({
      ...touched,
      [name]: true,
    });
  };

  const handleBlur = (field) => {
    setTouched({
      ...touched,
      [field]: true,
    });
  };

  const handleSubmit = () => {
    // 標記所有欄位為已觸碰
    setTouched({ userId: true, quantity: true });

    // 驗證所有欄位
    if (!validation.userId.isValid || !validation.quantity.isValid) {
      Swal.fire({
        title: '表單驗證失敗',
        text: '請檢查並修正表單中的錯誤',
        icon: 'error',
        confirmButtonText: '我知道了',
        confirmButtonColor: '#ef4444',
      });
      return;
    }

    // 發送確認
    Swal.fire({
      title: '確認發送公關券',
      text: `將發送 ${formData.quantity} 張優惠券給用戶 ${formData.userId}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: '確認發送',
      cancelButtonText: '取消',
      confirmButtonColor: '#6366f1',
      cancelButtonColor: '#6b7280',
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        bonusProductAPI
          .assignCouponToUser(
            bonusProductId,
            formData.userId,
            parseInt(formData.quantity, 10),
          )
          .then(
            () => {
              Swal.fire({
                title: '發送成功！',
                text: `已成功發送 ${formData.quantity} 張優惠券給用戶 ${formData.userId}`,
                icon: 'success',
                confirmButtonText: '完成',
                confirmButtonColor: '#10b981',
              });

              // 重置表單
              setFormData({
                userId: '',
                quantity: 1,
              });
              setTouched({
                userId: false,
                quantity: false,
              });

              close();
            },
            (error) => {
              alertError(error);
            },
          )
          .then(() => {
            setIsLoading(false);
          });
      }
    });
  };

  const isFormValid = validation.userId.isValid && validation.quantity.isValid;

  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={handleClose}
      fullWidth={true}
      maxWidth="sm"
      TransitionComponent={Zoom}
      transitionDuration={300}
      BackdropProps={{
        className: classes.backdrop,
      }}
      PaperProps={{
        className: classes.dialogPaper,
      }}>
      {/* Header */}
      <Fade in={isOpen} timeout={400}>
        <Box className={classes.header}>
          <IconButton
            className={classes.closeButton}
            onClick={close}
            disabled={isLoading}
            size="small">
            <CloseRoundedIcon fontSize="small" />
          </IconButton>

          <Box className={classes.iconWrapper}>
            <ConfirmationNumberRoundedIcon className={classes.iconSvg} />
          </Box>

          <Typography
            variant="h5"
            align="center"
            style={{ fontWeight: 700, marginBottom: 4, color: '#1f2937' }}>
            發送公關券
          </Typography>
          <Typography
            variant="body2"
            align="center"
            style={{ color: '#6b7280', fontSize: '0.938rem' }}>
            將優惠券發送給指定用戶
          </Typography>
        </Box>
      </Fade>

      {/* Content */}
      <DialogContent className={classes.content}>
        <Slide direction="up" in={isOpen} timeout={400}>
          <Box>
            {/* User ID Field */}
            <Box className={classes.formGroup}>
              <Typography className={classes.label}>
                <PersonOutlineRoundedIcon style={{ fontSize: 18 }} />
                用戶 ID
              </Typography>
              <TextField
                fullWidth
                name="userId"
                value={formData.userId}
                onChange={handleChange}
                onBlur={() => handleBlur('userId')}
                variant="outlined"
                disabled={isLoading}
                placeholder="請輸入用戶 ID（純數字）"
                error={touched.userId && !validation.userId.isValid}
                className={classes.inputField}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutlineRoundedIcon
                        style={{
                          color:
                            touched.userId && validation.userId.isValid
                              ? '#10b981'
                              : touched.userId && !validation.userId.isValid
                              ? '#ef4444'
                              : '#9ca3af',
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
              {touched.userId && (
                <Box
                  className={`${classes.validationMessage} ${
                    validation.userId.isValid
                      ? classes.successMessage
                      : classes.errorMessage
                  }`}>
                  {validation.userId.isValid ? (
                    <CheckCircleOutlineRoundedIcon style={{ fontSize: 16 }} />
                  ) : (
                    <ErrorOutlineRoundedIcon style={{ fontSize: 16 }} />
                  )}
                  {validation.userId.message}
                </Box>
              )}
            </Box>

            {/* Quantity Field */}
            <Box className={classes.formGroup}>
              <Typography className={classes.label}>
                <ConfirmationNumberRoundedIcon style={{ fontSize: 18 }} />
                發送數量
              </Typography>
              <TextField
                fullWidth
                name="quantity"
                type="number"
                value={formData.quantity}
                onChange={handleChange}
                onBlur={() => handleBlur('quantity')}
                variant="outlined"
                disabled={isLoading}
                placeholder="請輸入數量 (1-10000)"
                error={touched.quantity && !validation.quantity.isValid}
                className={classes.inputField}
                inputProps={{
                  min: 1,
                  max: 10000,
                  step: 1,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ConfirmationNumberRoundedIcon
                        style={{
                          color:
                            touched.quantity && validation.quantity.isValid
                              ? '#10b981'
                              : touched.quantity && !validation.quantity.isValid
                              ? '#ef4444'
                              : '#9ca3af',
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
              {touched.quantity && (
                <Box
                  className={`${classes.validationMessage} ${
                    validation.quantity.isValid
                      ? classes.successMessage
                      : classes.errorMessage
                  }`}>
                  {validation.quantity.isValid ? (
                    <CheckCircleOutlineRoundedIcon style={{ fontSize: 16 }} />
                  ) : (
                    <ErrorOutlineRoundedIcon style={{ fontSize: 16 }} />
                  )}
                  {validation.quantity.message}
                </Box>
              )}
            </Box>

            {/* Info Card */}
            {isFormValid && formData.userId && (
              <Grow in={isFormValid && !!formData.userId} timeout={400}>
                <Box className={classes.infoCard}>
                  <ConfirmationNumberRoundedIcon
                    style={{ color: '#6366f1', fontSize: 24, flexShrink: 0 }}
                  />
                  <Box>
                    <Typography
                      style={{
                        fontSize: '0.875rem',
                        fontWeight: 600,
                        color: '#1f2937',
                        marginBottom: 4,
                      }}>
                      確認發送信息
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '0.813rem',
                        color: '#6b7280',
                        lineHeight: 1.5,
                      }}>
                      將發送 <strong>{formData.quantity}</strong> 張優惠券給用戶{' '}
                      <strong>{formData.userId}</strong>
                    </Typography>
                  </Box>
                </Box>
              </Grow>
            )}
          </Box>
        </Slide>
      </DialogContent>

      {/* Actions */}
      <DialogActions className={classes.actions}>
        <Button
          className={`${classes.button} ${classes.cancelButton}`}
          onClick={close}
          disabled={isLoading}>
          取消
        </Button>
        <Button
          className={`${classes.button} ${classes.sendButton}`}
          variant="contained"
          onClick={handleSubmit}
          disabled={isLoading || !isFormValid}
          startIcon={!isLoading && <SendRoundedIcon />}>
          {isLoading ? (
            <Box display="flex" alignItems="center" gap={1}>
              <span>發送中</span>
              <Box display="flex" gap="4px" ml={0.5}>
                <span className={classes.loadingDot} />
                <span className={classes.loadingDot} />
                <span className={classes.loadingDot} />
              </Box>
            </Box>
          ) : (
            '確認發送'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BonusProductPRVoucherModal;
